// extracted by mini-css-extract-plugin
export default {"header":"header_header__LTkMm","date":"header_date__qFpQs","wrapper":"header_wrapper__r21rl","bellWrap":"header_bellWrap__U0npt"};